/* ─────────────────────────────────────────────────────────────
   US LOCATIONS CONFIG — static list of states and their major
   cities. Used in the Create Club form so users pick from
   dropdowns instead of typing freehand.

   Format: CITIES_BY_STATE[stateAbbr] = ['City1', 'City2', ...]
   Location string stored in DB: "City, ST" (e.g. "Austin, TX")
   ───────────────────────────────────────────────────────────── */

/* Common countries — United States first, rest alphabetical */
export const COUNTRIES = [
  'United States',
  'Australia',
  'Brazil',
  'Canada',
  'China',
  'France',
  'Germany',
  'India',
  'Japan',
  'Mexico',
  'Netherlands',
  'New Zealand',
  'Nigeria',
  'Poland',
  'Singapore',
  'South Korea',
  'Spain',
  'Sweden',
  'United Kingdom',
  'Other',
];

export const US_STATES = [
  { name: 'Alabama',              abbr: 'AL' },
  { name: 'Alaska',               abbr: 'AK' },
  { name: 'Arizona',              abbr: 'AZ' },
  { name: 'Arkansas',             abbr: 'AR' },
  { name: 'California',           abbr: 'CA' },
  { name: 'Colorado',             abbr: 'CO' },
  { name: 'Connecticut',          abbr: 'CT' },
  { name: 'Delaware',             abbr: 'DE' },
  { name: 'Florida',              abbr: 'FL' },
  { name: 'Georgia',              abbr: 'GA' },
  { name: 'Hawaii',               abbr: 'HI' },
  { name: 'Idaho',                abbr: 'ID' },
  { name: 'Illinois',             abbr: 'IL' },
  { name: 'Indiana',              abbr: 'IN' },
  { name: 'Iowa',                 abbr: 'IA' },
  { name: 'Kansas',               abbr: 'KS' },
  { name: 'Kentucky',             abbr: 'KY' },
  { name: 'Louisiana',            abbr: 'LA' },
  { name: 'Maine',                abbr: 'ME' },
  { name: 'Maryland',             abbr: 'MD' },
  { name: 'Massachusetts',        abbr: 'MA' },
  { name: 'Michigan',             abbr: 'MI' },
  { name: 'Minnesota',            abbr: 'MN' },
  { name: 'Mississippi',          abbr: 'MS' },
  { name: 'Missouri',             abbr: 'MO' },
  { name: 'Montana',              abbr: 'MT' },
  { name: 'Nebraska',             abbr: 'NE' },
  { name: 'Nevada',               abbr: 'NV' },
  { name: 'New Hampshire',        abbr: 'NH' },
  { name: 'New Jersey',           abbr: 'NJ' },
  { name: 'New Mexico',           abbr: 'NM' },
  { name: 'New York',             abbr: 'NY' },
  { name: 'North Carolina',       abbr: 'NC' },
  { name: 'North Dakota',         abbr: 'ND' },
  { name: 'Ohio',                 abbr: 'OH' },
  { name: 'Oklahoma',             abbr: 'OK' },
  { name: 'Oregon',               abbr: 'OR' },
  { name: 'Pennsylvania',         abbr: 'PA' },
  { name: 'Rhode Island',         abbr: 'RI' },
  { name: 'South Carolina',       abbr: 'SC' },
  { name: 'South Dakota',         abbr: 'SD' },
  { name: 'Tennessee',            abbr: 'TN' },
  { name: 'Texas',                abbr: 'TX' },
  { name: 'Utah',                 abbr: 'UT' },
  { name: 'Vermont',              abbr: 'VT' },
  { name: 'Virginia',             abbr: 'VA' },
  { name: 'Washington',           abbr: 'WA' },
  { name: 'West Virginia',        abbr: 'WV' },
  { name: 'Wisconsin',            abbr: 'WI' },
  { name: 'Wyoming',              abbr: 'WY' },
];

export const CITIES_BY_STATE = {
  AL: ['Birmingham', 'Montgomery', 'Huntsville', 'Mobile', 'Tuscaloosa', 'Hoover', 'Auburn'],
  AK: ['Anchorage', 'Fairbanks', 'Juneau', 'Sitka', 'Ketchikan'],
  AZ: ['Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale', 'Tempe', 'Gilbert', 'Glendale', 'Peoria'],
  AR: ['Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale', 'Jonesboro', 'Conway'],
  CA: ['Los Angeles', 'San Diego', 'San Jose', 'San Francisco', 'Fresno', 'Sacramento', 'Long Beach', 'Oakland', 'Bakersfield', 'Anaheim', 'Santa Ana', 'Riverside', 'Irvine', 'Stockton', 'Chula Vista', 'Berkeley', 'Pasadena', 'Sunnyvale', 'Santa Clara', 'Torrance'],
  CO: ['Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Lakewood', 'Thornton', 'Arvada', 'Boulder', 'Pueblo'],
  CT: ['Bridgeport', 'New Haven', 'Hartford', 'Stamford', 'Waterbury', 'Norwalk', 'Danbury', 'Greenwich'],
  DE: ['Wilmington', 'Dover', 'Newark', 'Middletown', 'Smyrna'],
  FL: ['Jacksonville', 'Miami', 'Tampa', 'Orlando', 'St. Petersburg', 'Hialeah', 'Tallahassee', 'Fort Lauderdale', 'Cape Coral', 'Pembroke Pines', 'Boca Raton', 'Gainesville', 'Sarasota', 'Naples'],
  GA: ['Atlanta', 'Augusta', 'Columbus', 'Macon', 'Savannah', 'Athens', 'Sandy Springs', 'Alpharetta', 'Marietta'],
  HI: ['Honolulu', 'Pearl City', 'Hilo', 'Kailua', 'Kaneohe', 'Waipahu'],
  ID: ['Boise', 'Meridian', 'Nampa', 'Idaho Falls', 'Pocatello', 'Coeur d\'Alene', 'Twin Falls'],
  IL: ['Chicago', 'Aurora', 'Joliet', 'Naperville', 'Rockford', 'Springfield', 'Elgin', 'Peoria', 'Champaign', 'Evanston', 'Waukegan'],
  IN: ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel', 'Fishers', 'Bloomington', 'Hammond', 'Lafayette'],
  IA: ['Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Iowa City', 'Waterloo', 'Dubuque'],
  KS: ['Wichita', 'Overland Park', 'Kansas City', 'Topeka', 'Olathe', 'Lawrence', 'Shawnee'],
  KY: ['Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington', 'Richmond', 'Georgetown'],
  LA: ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles', 'Kenner', 'Bossier City'],
  ME: ['Portland', 'Lewiston', 'Bangor', 'South Portland', 'Auburn', 'Augusta'],
  MD: ['Baltimore', 'Columbia', 'Germantown', 'Silver Spring', 'Waldorf', 'Glen Burnie', 'Gaithersburg', 'Rockville', 'Frederick', 'Ellicott City', 'Bethesda'],
  MA: ['Boston', 'Worcester', 'Springfield', 'Cambridge', 'Lowell', 'Brockton', 'New Bedford', 'Lynn', 'Quincy', 'Somerville', 'Newton'],
  MI: ['Detroit', 'Grand Rapids', 'Warren', 'Sterling Heights', 'Ann Arbor', 'Lansing', 'Flint', 'Dearborn', 'Livonia', 'Westland', 'Troy', 'Kalamazoo'],
  MN: ['Minneapolis', 'Saint Paul', 'Rochester', 'Duluth', 'Bloomington', 'Brooklyn Park', 'Plymouth', 'Maple Grove', 'Eden Prairie'],
  MS: ['Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi', 'Meridian', 'Tupelo'],
  MO: ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Independence', 'Lee\'s Summit', 'O\'Fallon', 'St. Joseph'],
  MT: ['Billings', 'Missoula', 'Great Falls', 'Bozeman', 'Butte', 'Helena', 'Kalispell'],
  NE: ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island', 'Kearney', 'Fremont'],
  NV: ['Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks', 'Carson City', 'Summerlin'],
  NH: ['Manchester', 'Nashua', 'Concord', 'Derry', 'Dover', 'Rochester', 'Portsmouth'],
  NJ: ['Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Edison', 'Woodbridge', 'Lakewood', 'Toms River', 'Hamilton', 'Trenton', 'Clifton', 'Camden', 'Dunellen'],
  NM: ['Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell', 'Farmington'],
  NY: ['New York City', 'Buffalo', 'Rochester', 'Yonkers', 'Syracuse', 'Albany', 'New Rochelle', 'Mount Vernon', 'Schenectady', 'Utica', 'White Plains', 'Hempstead'],
  NC: ['Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem', 'Fayetteville', 'Cary', 'Wilmington', 'High Point', 'Concord', 'Asheville'],
  ND: ['Fargo', 'Bismarck', 'Grand Forks', 'Minot', 'West Fargo'],
  OH: ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton', 'Parma', 'Canton', 'Youngstown', 'Lorain', 'Hamilton'],
  OK: ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Lawton', 'Edmond', 'Moore', 'Midwest City'],
  OR: ['Portland', 'Salem', 'Eugene', 'Gresham', 'Hillsboro', 'Beaverton', 'Bend', 'Medford', 'Springfield', 'Corvallis'],
  PA: ['Philadelphia', 'Pittsburgh', 'Allentown', 'Erie', 'Reading', 'Scranton', 'Bethlehem', 'Lancaster', 'Harrisburg', 'York', 'State College'],
  RI: ['Providence', 'Cranston', 'Warwick', 'Pawtucket', 'East Providence', 'Woonsocket', 'Newport'],
  SC: ['Columbia', 'Charleston', 'North Charleston', 'Mount Pleasant', 'Rock Hill', 'Greenville', 'Summerville', 'Spartanburg'],
  SD: ['Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings', 'Watertown', 'Mitchell'],
  TN: ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville', 'Murfreesboro', 'Franklin', 'Jackson', 'Johnson City'],
  TX: ['Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth', 'El Paso', 'Arlington', 'Corpus Christi', 'Plano', 'Lubbock', 'Laredo', 'Irving', 'Garland', 'Frisco', 'McKinney', 'Amarillo', 'Grand Prairie', 'Killeen', 'Waco', 'Denton'],
  UT: ['Salt Lake City', 'West Valley City', 'Provo', 'West Jordan', 'Orem', 'Sandy', 'Ogden', 'St. George', 'Layton'],
  VT: ['Burlington', 'South Burlington', 'Rutland', 'Barre', 'Montpelier', 'Winooski'],
  VA: ['Virginia Beach', 'Norfolk', 'Chesapeake', 'Richmond', 'Newport News', 'Alexandria', 'Hampton', 'Roanoke', 'Portsmouth', 'Suffolk', 'Charlottesville', 'Arlington'],
  WA: ['Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue', 'Kent', 'Renton', 'Kirkland', 'Everett', 'Redmond', 'Olympia', 'Bellingham'],
  WV: ['Charleston', 'Huntington', 'Parkersburg', 'Morgantown', 'Wheeling', 'Weirton'],
  WI: ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine', 'Appleton', 'Waukesha', 'Oshkosh', 'Eau Claire', 'Janesville'],
  WY: ['Cheyenne', 'Casper', 'Laramie', 'Gillette', 'Rock Springs', 'Sheridan'],
};
